import React from 'react';
import { Field, useField } from 'formik';

interface Props {
    name: string;
    label: string;
    value: string | number;
}

export default function Checkbox(props: Props) {
    const [field] = useField(props.name);
    return (
        <div>
            <label>
                <Field
                    type="checkbox"
                    name={props.name}
                    value={props.value}
                    checked={field.checked}
                />
                {props.label}
            </label>
        </div>
    );
}
